module.exports = __webpack_public_path__ + "img/album01_01.8289e574.jpg";